import Configuration from "./configuration";

class ConfigurationService {
  constructor(token) {
    this.config = new Configuration(token, null, "api/Configuration");
  }

  /**
   * @method getConfigurationCompany get information company
   * @return {Promise} result object customers
   */
  async getConfigurationCompany() {
    return this.config.API.get(`GetConfigurationCompany`, {
      params: {
        companyId: this.config.companyId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method saveConfigurationCompany save information company
   * @return {Promise} result object customers
   */
  async saveConfigurationCompany(configuration) {
    return this.config.API.post(`SaveConfigurationCompany`, configuration, {
      params: {
        companyId: this.config.companyId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method getProvidersIntegration get information providers
   * @return {Promise} result object providers
   */
  async getProvidersIntegration(typeProviderIntegration = 0) {
    return this.config.API.get(`GetProvidersIntegration`, {
      params: {
        typeProviderIntegration
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method getConfiguration get information providers
   * @return {Promise} result object providers
   */
  async getConfiguration() {
    return this.config.API.get(`GetConfiguration`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method saveConfiguration save information company
   * @return {Promise} result object customers
   */
  async saveConfiguration(configuration) {
    // set null provaider if not exist
    configuration.pr =
      configuration.pr && configuration.pr.disarrayConfiguration
        ? configuration.pr
        : null;
    configuration.erp =
      configuration.erp && configuration.erp.disarrayConfiguration
        ? configuration.erp
        : null;
    configuration.sed =
      configuration.sed && configuration.sed.disarrayConfiguration
        ? configuration.sed
        : null;
    configuration.mailing =
      configuration.mailing && configuration.mailing.disarrayConfiguration
        ? configuration.mailing
        : null;
    configuration.sms =
      configuration.sms && configuration.sms.disarrayConfiguration
        ? configuration.sms
        : null;

    return this.config.API.post(`SaveConfiguration`, configuration).then(
      response => {
        if (response.status !== 200) {
          return this.config.handleResponseError(response);
        }
        return response.data;
      }
    );
  }
}

export default ConfigurationService;
